<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :disabled="!!regulador"
                    :options="data.form.unidades"
                    :validations="validations.unidade"
                    @change="handleUnidadeChange"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :disabled="!!regulador"
                    :options="data.form.infraestruturas"
                    :validations="validations.infraestrutura"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :disabled="disableTipo"
                    :options="data.form.tipos"
                    :validations="validations.tipo"
                    label="Tipo"
                    show-default-option
                    text-field="nome"
                    v-model="model.tipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox
                    :label="false"
                    v-model="model.solicitanteControlaProtocoloFechamento"
                >
                    Solicitante controla protocolo de fechamento
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, error, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Enums.
import reguladorTipo from '@/enums/regulacao/reguladorTipo'

export default {
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
                tipo: { required: true },
            }
        },
        disableTipo() {

            if (this.model.infraestruturaId && this.model.tipoId === this.enums.reguladorTipo.MUNICIPAL) {

                return this.data.model.solicitantes.some(s => !!s.reguladores
                    .find(r => r.infraestruturaId === this.model.infraestruturaId
                        && r.infraestruturaId !== s.infraestruturaId)
                )
            }

            return false
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }

        if (this.regulador) {

            this.loadRegulador()
        }
    },
    data: () => ({
        model: {
            id: null,
            ativo: true,
            unidadeId: null,
            infraestruturaId: null,
            tipoId: null,
            solicitanteControlaProtocoloFechamento: false,
            exames: [],
            procedimentosCirurgicos: [],
            especialidades: [],
        },
        enums: { reguladorTipo },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        loadRegulador() {

            Object.assign(this.model, this.regulador)

            this.loadInfraestruturas()
        },
        handleUnidadeChange() {

            this.data.form.infraestruturas = []
            this.model.infraestruturaId = null

            if (this.model.unidadeId) {

                this.loadInfraestruturas()
            }
        },
        loadInfraestruturas() {

            this.setLoading()

            this.repositories.parametrizacao.list({
                listar: 'infraestruturas',
                unidade_id: this.model.unidadeId
            })
                .then(({ data }) => {

                    this.data.form.infraestruturas = data

                    if (this.data.form.infraestruturas.length === 1) {

                        this.model.infraestruturaId = this.data.form.infraestruturas[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (!this.regulador && this.infraestruturaJaAdicionada()) {

                        this.showValidationNotification('O local de atendimento já foi incluído.')

                        return
                    }

                    if (this.regulador) {

                        Object.assign(this.originalRegulador, this.prepareData())
                    }
                    else {

                        this.data.model.reguladores.push(this.prepareData())
                    }

                    this.$emit('save')
                })
        },
        infraestruturaJaAdicionada() {

            return !!this.data.model.reguladores.find(r => r.infraestruturaId === this.model.infraestruturaId)
        },
        prepareData() {

            const data = this.clone(this.model)

            data.unidadeNomeFantasia = this.data.form.unidades.find(u => u.id === data.unidadeId).nomeFantasia
            data.infraestruturaNome = this.data.form.infraestruturas.find(u => u.id === data.infraestruturaId).nome
            data.tipoNome = this.data.form.tipos.find(t => t.id === data.tipoId).nome

            return data
        }
    },
    mixins: [repository, error, object],
    props: {
        data: { type: Object, required: true },
        originalRegulador: { type: Object },
        regulador: { type: Object },
    },
}
</script>